// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: var(--color-card-background);
  color: var(--color-card-text);
  border: none;
}

.cardtitle {
  font-weight: 600;
  font-size: 18px;
}

.contact {
  margin-bottom: 15px;
}

li {
  margin-top: 10%;
}

ol {
  padding-left: 15px;
}

.btn-next:focus {
  outline: none;
}

.header {
  position: relative;
  text-align: center;
  color: white;
}
.header img {
  height: 260px;
  width: 100%;
  object-fit: cover;
}

.top-right {
  position: absolute;
  top: 8px;
  left: 80px;
}

.centered {
  position: absolute;
  font-size: 36px;
  font-weight: 700;
  top: 50%;
  width: 80%;
  transform: translate(12%, -50%);
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/return-created/return-created.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,8CAAA;EACA,6BAAA;EACA,YAAA;AACF;;AACA;EACE,gBAAA;EACA,eAAA;AAEF;;AAAA;EACE,mBAAA;AAGF;;AADA;EACE,eAAA;AAIF;;AAFA;EACE,kBAAA;AAKF;;AAHA;EACE,aAAA;AAMF;;AAJA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AAOF;AANE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AAQJ;;AALA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAQF;;AANA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;AASF","sourcesContent":[".card {\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  background-color: var(--color-card-background);\n  color: var(--color-card-text);\n  border: none;\n}\n.cardtitle {\n  font-weight: 600;\n  font-size: 18px;\n}\n.contact {\n  margin-bottom: 15px;\n}\nli {\n  margin-top: 10%;\n}\nol {\n  padding-left: 15px;\n}\n.btn-next:focus {\n  outline: none;\n}\n.header {\n  position: relative;\n  text-align: center;\n  color: white;\n  img {\n    height: 260px;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n.top-right {\n  position: absolute;\n  top: 8px;\n  left: 80px;\n}\n.centered {\n  position: absolute;\n  font-size: 36px;\n  font-weight: 700;\n  top: 50%;\n  width: 80%;\n  transform: translate(12%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
